import { ReactNode } from 'react';
import { Grid2 as Grid, Box, Typography, TypographyProps, BoxProps, useTheme } from '@mui/material';
import { responsivePagePadding } from '../../utils/constants';

function TitleTextGen({
  boxProps,
  children,
  id,
  text,
  textProps,
  title,
  titleSecondary,
  titleProps,
}: {
  boxProps?: BoxProps;
  children?: ReactNode;
  id?: string;
  text?: any;
  textProps?: TypographyProps;
  title?: string;
  titleSecondary?: boolean;
  titleProps?: TypographyProps;
}) {
  const theme = useTheme();

  return (
    <Box
      id={`${id}`}
      {...boxProps}
      sx={{
        padding: responsivePagePadding,
        ...boxProps?.sx,
      }}
    >
      <Typography
        gutterBottom
        variant="h3"
        color={`${titleSecondary ? theme.palette.primary.light : theme.palette.primary.main}`}
        {...titleProps}
      >
        {title}
      </Typography>
      <Typography gutterBottom variant="body1" {...textProps}>
        {text}
      </Typography>
      {children}
    </Box>
  );
}

export default TitleTextGen;
